/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import * as api from '@/api/user';
import { USER } from '@/store/types';
import listModule, { StoreUserCoinListState } from './list';
import mineModule, { StoreUserCoinMineState } from './mine';

export interface StoreUserCoinState {
  // modules
  list: StoreUserCoinListState;
  mine: StoreUserCoinMineState;
}

export default {
  namespaced: true,
  modules: {
    list: listModule,
    mine: mineModule,
  },
  state: {},
  getters: {},
  actions: {
    [USER.POST_COIN_TRANSFER](_, { amount }) {
      return new Promise((resolve, reject) => {
        api.postCoinTransfer(amount).then(() => {
          resolve();
        }).catch(reject);
      });
    },
  },
  mutations: {},
};
